export * from "./InputLabel";
export { activeLabelStyles } from "./styles";